import { BaseEntity } from "./BaseEntity";

export class ConnectionEntity extends BaseEntity {
    constructor() {
        super();

        this.entityName = "components.contracts.connection.connection";
        this.pageTitle = "components.contracts.connection.pageTitle";
        this.menuPath = "/Resources";
        this.APIRoute = "Resources/Contracts"
        this.i18nBase = "components.contracts.connection";
        this.baseEndPoint = "/radius/clientaccess";
        this.endpoints = {
            list: `${this.baseEndPoint}`,
            create: `${this.baseEndPoint}`,
            get: `${this.baseEndPoint}/:id`,
            delete: `${this.baseEndPoint}/:id`
        };

        this.fields = [
            {
                key: "id",
                label: "common.labels.code",
                type: "hidden",
                visible: true,
                editable: true,
                cols: 12,
                path: "id"
            },
            {
                key: "nasName",
                label: "NAS",
                type: "text",
                visible: true,
                editable: true,
                cols: 6,
                path: "nasName"
            },
            {
                key: "username",
                label: `${this.i18nBase}.username`,
                type: "text",
                visible: true,
                editable: true,
                path: "username",
                cols: 3
            },
            {
                key: "clientaccessState",
                label: `${this.i18nBase}.clientaccessState`,
                type: "text",
                visible: true,
                cols: 3,
                path: "clientaccessState"
            },
            {
                key: "max_download",
                label: "Max download",
                type: "text",
                visible: true,
                cols: 3,
                path: "max_download"
            },
            {
                key: "max_upload",
                label: "Max upload",
                type: "text",
                visible: true,
                cols: 3,
                path: "max_upload"
            },
            {
                key: "connection_type",
                label: `${this.i18nBase}.connectionType`,
                type: "text",
                visible: true,
                cols: 3,
                path: "connection_type"
            },
            {
                key: "poolV4",
                label: "poolV4",
                type: "text",
                visible: true,
                cols: 3,
                path: "poolV4"
            },
            {
                key: "poolV6",
                label: "poolV6",
                type: "text",
                visible: true,
                cols: 3,
                path: "poolV6"
            },
            {
                key: "ip_v6_wan_prefix",
                label: "ipv6 wan prefix",
                type: "text",
                visible: true,
                cols: 3,
                path: "ip_v6_wan_prefix"
            },
            {
                key: "ip_v6_pd_prefix",
                label: "ipv6 pd prefix",
                type: "text",
                visible: true,
                cols: 3,
                path: "ip_v6_pd_prefix"
            },
            {
                key: "ip_v4_wan",
                label: "ipv4 wan",
                type: "text",
                visible: true,
                cols: 3,
                path: "ip_v4_wan"
            },
        ]

        this.customActions = {
            duplicate: false
        }

        this.tableProducts = [
            {
                key: "name",
                label: "common.labels.name",
                smallScreenMaxChars: 60,
                maxChars: 90,
                visible: true,
                orderBy: true
            },
            {
                key: "actions",
                label: "common.labels.actions",
                visible: true,
                orderBy: false
            },
        ]

        this.tableColumns = [
            {
                key: "nasName",
                label: "NAS",
                visible: true,
                orderBy: true
            },
            {
                key: "username",
                label: `${this.i18nBase}.username`,
                visible: true,
                orderBy: false
            },
            {
                key: "max_upload",
                label: "Max Upload",
                visible: true,
                orderBy: false
            },
            {
                key: "max_download",
                label: "Max download",
                visible: true,
                orderBy: false
            },
            {
                key: "clientaccess_state",
                label: `${this.i18nBase}.clientaccessState`,
                visible: true,
                orderBy: false
            },
            {
                key: "actions",
                label: "common.labels.actions",
                visible: true,
                orderBy: false
            },
        ]

        this.pages = {
            view: {
                pageTitle: `${this.i18nBase}.connection`,
                pathI18n: `components.settings.permissionManagement.menuList.Contracts/${this.i18nBase}.pageTitle`,
                route: ["/contracts","/contracts/connections", "/contracts/connections/view/:id"]
            },
            list: {
                pageTitle: `${this.i18nBase}.pageTitle`,
                pathI18n: "components.settings.permissionManagement.menuList.Contracts",
                route:  ["/contracts","/contracts/connections"],
                filters: {
                    quickSearch: {
                        info: "common.messages.info.searchByName",
                        searchBy: ["username"],
                        type: "text",
                    },
                    advanced: {
                        fields: [
                            {
                                key: "nasname",
                                label: "NAS",
                                type: "text",
                                path:"nasname"
                            },
                        ],
                    },
                },
            },
        };
    }

    getUrl(endpoint, params = {}) {
        let url = endpoint;
        Object.keys(params).forEach(key => {
            url = url.replace(`:${key}`, params[key]);
        });
        return url;
    }
}
